import { Combobox } from '@/components'
import { useTranslate } from '@ur-solutions/react-hooks'
import type { ExportFormat, ExportOption } from '../../consts'
import { useExportFormatOptions, useExportOptions } from '../../hooks'
import { ExportField } from './export-field'

interface ExportMethodFieldProps {
  value: ExportOption
  allowDownload?: boolean
  onChange(value: ExportOption): void
}

export const ExportMethodField: React.FC<ExportMethodFieldProps> = ({
  value,
  allowDownload = false,
  onChange,
}) => {
  const translations = useTranslate({
    exportMethod: 'common.export-method',
  })
  const options = useExportOptions(allowDownload)

  return (
    <ExportField label={translations.exportMethod}>
      <Combobox
        mode="single"
        noSearch
        value={value}
        items={options}
        onChange={option => {
          if (option) onChange(option)
        }}
      />
    </ExportField>
  )
}

interface ExportFormatFieldProps {
  value: ExportFormat
  exclude?: ExportFormat[]
  disabled?: boolean
  hint?: string | null
  onChange(value: ExportFormat): void
}

export const ExportFormatField: React.FC<ExportFormatFieldProps> = ({
  value,
  exclude,
  disabled = false,
  hint,
  onChange,
}) => {
  const translations = useTranslate({
    format: 'common.format',
  })
  const options = useExportFormatOptions(exclude)

  return (
    <ExportField label={translations.format}>
      <Combobox
        mode="single"
        noSearch
        disabled={disabled}
        value={value}
        items={options}
        onChange={format => {
          if (format) onChange(format)
        }}
      />
      {!!hint && <p className="ml-1 text-xs text-stone-500">{hint}</p>}
    </ExportField>
  )
}
